<!--suppress JSUnresolvedVariable -->
<template>
  <div class="careers  py-5">
    <div class="container">
      <h3 class="text-center text-info font-weight-bold wow fadeInDown">
        加入
        <img
          :src="titleImgUrl"
          alt="logo"
          width="50"
          height="50"
          class="rounded-circle mx-2"
        />
        我们
      </h3>
      <div class="text-center mb-4 text-secondary wow fadeInUp">
        —— {{ sectionSubTitle }} ——
      </div>
      <div class="row">
        <div
          class="mb-5 mb-md-3 col-12 col-sm-6 col-lg-3"
          v-for="item in jobList"
          :key="item.jobId"
        >
          <div class="card border-0 shadow">
            <div class="card-header font-weight-bold text-white bg-info">
              招聘职位：{{ item.jobName }}
            </div>
            <div class="card-body">
              <p class="card-text text-muted" v-html="item.jobContent"></p>
              <a
                class="btn btn-outline-info btn-sm mt-2 text-info"
                @click="updateJobViews(item.jobId)"
                >查看详情</a
              >
            </div>
            <div class="card-footer text-white bg-info">
              发布日期：{{ item.publishTime }}
            </div>
          </div>
        </div>
      </div>
      <div class="text-center mt-4 wow fadeInDown">
        <router-link
          to="/toRecruitmentCenter"
          class="text-info find-more font-weight-bold"
        >
          <img :src="moreImgUrl" alt="logo" width="40" class="rounded-circle" />
          查看更多
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
// noinspection ES6CheckImport
import { WOW } from "wowjs";

export default {
  name: "Careers",
  data() {
    return {
      titleImgUrl: "",
      sectionSubTitle: "",
      moreImgUrl: "",
      logSys: 1,
      jobList: []
    };
  },
  mounted() {
    let options = { live: false };
    new WOW(options).init();
    this.isSystem();
    this.getNavById();
    this.getHomeJobList();
  },
  methods: {
    isSystem() {
      if (navigator.userAgent.match("Android")) {
        this.logSys = 2;
      } else if (navigator.userAgent.match("iPhone")) {
        this.logSys = 3;
      } else if (navigator.userAgent.match("iPad")) {
        this.logSys = 3;
      } else {
        this.logSys = 1;
      }
    },
    getNavById() {
      this.axios
        .get("/navigation/getNavById/" + 5)
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.titleImgUrl = resp.data.data.titleImg;
            this.sectionSubTitle = resp.data.data.subTitle;
            this.moreImgUrl = resp.data.data.moreImgUrl;
          }
        })
        .catch();
    },
    getHomeJobList() {
      this.axios
        .get("/job/getHomeJobList")
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.jobList = resp.data.data;
          }
        })
        .catch();
    },
    updateJobViews(jobId) {
      this.axios
        .put("/job/updateJobViews/" + jobId, {
          logSys: this.logSys
        })
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.$router
              .push({ name: "CareersDetail", params: { jobId: jobId } })
              .catch();
          }
        })
        .catch(failResponse => {
          console.log(failResponse);
        });
    }
  }
};
</script>

<style scoped lang="scss">
.careers {
  .container {
    .find-more {
      font-size: 18px;
    }
    @media only screen and (min-width: 576px) {
      .find-more {
        font-size: 14px;
      }
    }
    .row {
      div {
        .card {
          .card-body {
            h6 {
              font-size: 14px;
            }

            p {
              height: 133px;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 4;
              overflow: hidden;
            }
          }
        }
      }
    }
  }
}
</style>
